import { useContext } from 'react';
import { getApolloContext } from '@apollo/client';
/**
 * Validates that EventComposer/EventDetails has all required context providers
 * in its React tree. Throws helpful errors if contexts are missing.
 *
 * This hook should be called at the top level of the component to fail fast
 * with clear error messages if required setup is missing.
 */
export function useRequiredContexts() {
    var apolloContext = useContext(getApolloContext());
    if (!(apolloContext === null || apolloContext === void 0 ? void 0 : apolloContext.client)) {
        throw new Error("EventComposer/EventDetails/SpaceBooking requires ApolloProvider to be present in the component tree.\n\nThe component uses Apollo Client hooks (useQuery, useMutation) internally and requires\nan ApolloProvider to be configured in your application.\n\nSetup Example:\n--------------\nimport { ApolloProvider } from '@apollo/client';\nimport { EventComposer } from '@robinpowered/dashboard-apps-patterns';\n\n<ApolloProvider client={apolloClient}>\n  <EventComposer {...props} />\n</ApolloProvider>\n\nDocumentation:\n--------------\n- Apollo Provider: https://www.apollographql.com/docs/react/api/react/hooks/#the-apolloprovider-component\n- Package README: See Prerequisites section");
    }
    return {
        apolloClient: apolloContext.client,
    };
}
